import React from 'react';
import { View } from 'react-native-web';
import Title from '../Text/Title';
import BreakLine from '../General/BreakLine';
import SwitcherPanel from '../Buttons/SwitcherPanel';
import {
  bars_enam,
  Bars_str,
  round_enam, RoundButtons_str, select_design_service_buttons,
  Show_account_balance,
  Show_greeting, square_enam, SquareButtons_str,
} from '../../../utils/DictionaryManagementUtils';
import LayoutMenu from './LayoutMenu';
import { LocStr } from '../../../utils/Utils';

//= ========================================================================

const MenuDesign = ({
  globJSON,
  onConfigChanged,
  onValueChanged,
  showAccountBalance,
  headline,
  language,
}) => {
  const layoutList = [
    {
      text: Bars_str,
      value: bars_enam,
    }, {
      text: SquareButtons_str,
      value: square_enam,
    }, {
      text: RoundButtons_str,
      value: round_enam,
    },
  ];
  return (
    <View>
      <BreakLine marginTop={20} />
      <Title isBold>{headline}</Title>
      <SwitcherPanel
        text={Show_greeting}
        value={globJSON.configurations.services.menu.welcome_title}
        onValueChanged={(value) => {
          onValueChanged('welcome_title', value);
        }}
      />
      {showAccountBalance
        && (
        <SwitcherPanel
          text={Show_account_balance}
          value={globJSON.configurations.services.menu.show_account_balance}
          onValueChanged={(value) => {
            onValueChanged('show_account_balance', value);
          }}
        />
        )}
      <LayoutMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        paragraph={LocStr(select_design_service_buttons, language)}
        list={layoutList}
      />
    </View>

  );
};
export default MenuDesign;
